export default __webpack_public_path__ + "static/media/opportunity_is_a_human_right.af74e20d.png";